import type { Prompt, PromptFolder } from ".";

export type OtherPrompts =
	| AutomaticMemoryGenerationPrompt
	| ChatTitleGenerationPrompt
	| SessionTitleGenerationPrompt
	| RephraseQueryPrompt
	| SuggestedPromptGenerationPrompt
	| ExtractPresentationSlideMetadataPrompt
	| MultiplePresentationSlidesGenerationPrompt
	| SlideRecommendationPrompt
	| SlideDeckPlanningPrompt;

/* eslint-disable @typescript-eslint/naming-convention */
export const otherPromptFolders = {
	"automatic-memory-generation": "other",
	"chat-title-generation": "other",
	"session-title-generation": "other",
	"rephrase-query": "other",
	"suggested-prompts-generation": "other",
	"pptx-slide-metadata-extraction": "other",
	"multiple-presentation-slides-generation": "study",
	"slide-recommendation": "other",
	"slide-deck-planning": "pptx",
} as const satisfies Record<OtherPrompts["name"], PromptFolder>;
/* eslint-enable @typescript-eslint/naming-convention */

export interface AutomaticMemoryGenerationPrompt extends Prompt {
	name: "automatic-memory-generation";
	variables: {
		query: string;
		userName: string;
		memoryContents: string;
	};
}

export interface ChatTitleGenerationPrompt extends Prompt {
	name: "chat-title-generation";
}

export interface SessionTitleGenerationPrompt extends Prompt {
	name: "session-title-generation";
}

export interface RephraseQueryPrompt extends Prompt {
	name: "rephrase-query";
	variables: {
		query: string;
		language: string;
		date: string;
	};
}

export interface SuggestedPromptGenerationPrompt extends Prompt {
	name: "suggested-prompts-generation";
	variables: {
		documents: string;
		query: string;
		language: string;
		date: string;
	};
}

export interface ExtractPresentationSlideMetadataPrompt extends Prompt {
	name: "pptx-slide-metadata-extraction";
	variables: {
		slideJson: string;
	};
}

export interface MultiplePresentationSlidesGenerationPrompt extends Prompt {
	name: "multiple-presentation-slides-generation";
	variables: {
		content: string;
		slideDescription: string;
		keepMyWording: string;
	};
}

export interface SlideRecommendationPrompt extends Prompt {
	name: "slide-recommendation";
	variables: {
		sourceContent: string;
		availableTemplates: string;
	};
}

export interface SlideDeckPlanningPrompt extends Prompt {
	name: "slide-deck-planning";
	variables: {
		sections: string;
		structure: string;
		availableSlides: string;
		deckContext: string;
	};
}
